import { render, staticRenderFns } from "./UserAdminToolbar.vue?vue&type=template&id=b0b04350&scoped=true&"
import script from "./UserAdminToolbar.vue?vue&type=script&lang=js&"
export * from "./UserAdminToolbar.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminToolbar.vue?vue&type=style&index=0&id=b0b04350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b04350",
  null
  
)

export default component.exports